import classNames from 'classnames';

import { Button, ButtonVariant, Icon, LinkAsButton, useModal } from '@/shared/ui';

import { ROUTES_BY_SERVICE_CODE } from '@/router/config';

import { formatDate } from '@/helpers/dates';

import { Truncatable } from '../../Truncatable/Truncatable';
import { Typography } from '../../Typography';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { DraftData, ServiceRowCardVariant } from '../model/types';

import { ConfirmDeleteUserRequestDraftModal } from './Modals';
import { Row, RowRenderer } from './RowRenderer';
import { StatusStep } from './StatusStep/StatusStep';

export interface UserRequestDraftCardProps {
  variant: ServiceRowCardVariant.USER_REQUEST_DRAFT;
  data: DraftData;
}

export const UserRequestDraftCard: React.FC<UserRequestDraftCardProps> = ({
  data: { id, title, createdAt, updatedAt, currentStep, totalSteps, serviceCode },
  variant,
}) => {
  const { isOpen, openModal, closeModal } = useModal();

  const rows: Row[] = [
    {
      label: 'Дата створення',
      value: formatDate(createdAt),
      dataTestId: 'user-request-draft-card-date',
    },
    {
      label: 'Дата оновлення',
      value: formatDate(updatedAt),
      dataTestId: 'user-request-draft-card-date',
    },
  ];

  return (
    <>
      <ConfirmDeleteUserRequestDraftModal isModalOpen={isOpen} closeModal={closeModal} draftIdToDelete={id} />
      <BaseCard
        data-testid="user-request-draft-card"
        data-request-id={id}
        className={classNames('service-row-card', `service-row-card--${variant}`)}
        header={
          <div className="service-row-card__header">
            <div data-testid="user-request-draft-card-status" className="service-row-card__status-wrapper">
              <StatusStep step={currentStep} maxSteps={totalSteps} />
            </div>
            <div className="service-row-card__title-wrapper">
              <Truncatable text={<Typography variant="H4">{title}</Typography>} />
            </div>
          </div>
        }
        body={
          <div className="service-row-card__meta-wrapper">
            <RowRenderer rows={rows} />
          </div>
        }
        actions={[
          <LinkAsButton
            key="continue-draft"
            variant={ButtonVariant.GHOST}
            to={ROUTES_BY_SERVICE_CODE[serviceCode]}
            state={{
              continueDraft: true,
              request_id: id,
            }}
          >
            <Icon name="arrow_forward" />
            Продовжити
          </LinkAsButton>,
          <Button key="delete-draft" variant={ButtonVariant.GHOST_WARNING} onClick={openModal}>
            <Icon name="delete" />
            Видалити
          </Button>,
        ]}
      />
    </>
  );
};
